module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "information-container"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveRequisites()
      }
    }
  }, [_vm._v(_vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ'))])]), _vm._v(" "), (_vm.requisitesData) ? _c('div', {
    staticClass: "columns is-multiline requisites",
    model: {
      value: (_vm.requisitesData),
      callback: function($$v) {
        _vm.requisitesData = $$v
      },
      expression: "requisitesData"
    }
  }, _vm._l((_vm.requisitesData), function(requisite) {
    return _c('RequisiteItem', {
      key: requisite.id,
      attrs: {
        "object": requisite
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "centered add-document"
  }, [_c('span', {
    staticClass: "button-wrapper link",
    on: {
      "click": _vm.handleAddRequisite
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить реквизит\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eee1a82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information/Requisites.vue
// module id = 920
// module chunks = 0